// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"6132b4bc","732":"2ae9d074","977":"35bd29ab"}[chunkId] + ".chunk.js");